/* eslint-disable node/no-extraneous-import */
import aspectRatio from './aspectRatio'
import avoid from './avoid'
import restrictEdges from './restrict/edges'
import restrict from './restrict/pointer'
import restrictRect from './restrict/rect'
import restrictSize from './restrict/size'
import rubberband from './rubberband'
import snapEdges from './snap/edges'
import snap from './snap/pointer'
import snapSize from './snap/size'
import spring from './spring'
import transform from './transform'

export default {
  aspectRatio,
  restrictEdges,
  restrict,
  restrictRect,
  restrictSize,
  snapEdges,
  snap,
  snapSize,

  spring,
  avoid,
  transform,
  rubberband,
}
